import { Button, Container } from "reactstrap";
import Header from "../../components/globals/Header";
import MainNavigatorTab from "../../components/navigators/MainNavigatorTab";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useURLSearchParams } from "../../hooks/utilityHooks";
import { dummyPlaces, placesNavigatorOptions } from "../../dummyData";
import { IoIosAddCircleOutline } from "react-icons/io";
import CustomizableSpecialDropdown from "../../components/specials/CustomizableSpecialDropdown";
import ItemsCard from "../../components/cards/ItemsCard";
import MyPlaceCard from "../../components/cards/MyPlaceCard";
import { SpecialEventAddIcon } from "../../assets/designedPickedIcons";
import InfoModal from "../../components/modals/InfoModal";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
import { useDispatch, useSelector } from "react-redux";
import { setPlaceDetails } from "../../redux/action";
import { StatusTabPressPlaceDetailsApis } from "../../apis/PlacesApis";
import { useTranslation } from "../../languages";
const MyPlaces = () => {
  const { goTo } = useURLSearchParams();
  const [flowAt, setFlowAt] = useState(goTo ?? 0);
  const [statusShown, setStatusShown] = useState("");
  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  const [placesData, setPlacesData] = useState([]);
  useEffect(() => {
    const fetchStatusItems = async () => {
      const result = await StatusTabPressPlaceDetailsApis(statusShown);
      if (result.success) {
        setPlacesData(result?.data?.places || []);
      } else {
        setPlacesData([]);
      }
    };
    fetchStatusItems();
  }, [statusShown]);
  const {
    // all functions for my places
  } = usePlaceHooks();
  const { t } = useTranslation();
  return (
    <div>
      <Container fluid>
        <Header title={t("myPlaces")} />
        <MainNavigatorTab
          flowAt={flowAt}
          items={placesNavigatorOptions}
          setFlowAt={setFlowAt}
          onItemClick={(item) => setStatusShown(item?.val)}
        >
          <CustomizableSpecialDropdown
            toggler={
              <Link
                style={{ borderRadius: "34px" }}
                className="btn text-white inner-shadow-white  border-none bg-primary-blue d-flex align-items-center gap-1"
              >
                <IoIosAddCircleOutline size={20} />
                {t("addNew")}
              </Link>
            }
          >
            <Link
              to={"/places/addplaces"}
              className={`btn py-3 d-flex align-items-center gap-1  justify-content-start f-5 bg-transparent border-none `}
            >
              <p className="m-0"> {t("addActivityLocation")}</p>
            </Link>
            <div className="horizontal-line"></div>
            <Button
              onClick={() => navigateTo("/events/addEvent")}
              className={`btn d-flex full-width py-3 align-items-center full-width gap-1  justify-content-between f-5 bg-transparent border-none `}
            >
              <p className="m-0">{t("addYourEvent")}</p>
              <div
                className="bg-purple p-1"
                style={{ borderRadius: "50%" }}
                onClick={(e) => e?.stopPropagation()}
              >
                <InfoModal
                  iconSize={24}
                  cancelEventPropagation={true}
                  cancelDefaultPosition={true}
                  text={` If you are planing an event that is not associated with an activity company with a fixed location, please create your event profile using the "add Event" button`}
                />
              </div>
            </Button>
            <div className="horizontal-line"></div>
            {/* <Button
              onClick={(e) => navigateTo("/events/addSpecialEvent")}
              className={`btn d-flex align-items-center full-width py-2 mb-3 gap-1  justify-content-between f-5 bg-transparent border-none `}
            >
              <div className="d-flex gap-1 align-items-center">
                <SpecialEventAddIcon size={36} />
                <p className="m-0 text-gradient-1">{t("addSpecialEvent")}</p>
              </div>
              <div
                className="bg-purple p-1"
                style={{ borderRadius: "50%" }}
                onClick={(e) => e?.stopPropagation()}
              >
                <InfoModal
                  iconSize={24}
                  cancelEventPropagation={true}
                  cancelDefaultPosition={true}
                  text={` If you plan a special Event on your active activity location add the special Event page for your activity profile over the "Add Special Event"  button.`}
                />
              </div>
            </Button> */}
          </CustomizableSpecialDropdown>
        </MainNavigatorTab>
        <div className="mt-4">
          <ItemsCard
            itemsPerPage={6}
            items={placesData}
            renderItem={(item, key) => (
              <MyPlaceCard details={item} index={key} />
            )}
          />
        </div>
      </Container>
    </div>
  );
};
export default MyPlaces;
